<template>
  <el-dialog
    :close-on-click-modal="false"
    :title="programCardList.id? $l('programCard.edit','编辑节目单'):$l('programCard.add','新增节目单')"
    :visible.sync="dialogVisible"
    class="small-padding"
    top="2vh"
    width="1100px"
    @close="$reset('form')">
    <div style="display: flex">
      <div style="flex:1; margin-right: 20px; ">
        <el-form
          ref="form"
          :model="programCardList"
          class="form"
          :label-width="$l('150px','80px')">
          <el-form-item :label="$l('programCard.programCardName','节目单名称')" prop="cardName" :rules="$rule.notNull">
            <el-input v-model="programCardList.cardName" :placeholder="$t('common.pleaseEnter')"></el-input>
          </el-form-item>
          <el-form-item :label="$l('programCard.notice','公告')" prop="notice">
            <el-input
              v-model="programCardList.notice"
              :placeholder="$t('common.pleaseEnter')"
              rows="3"
              type="textarea"></el-input>
          </el-form-item>
          <div v-if="$i18n.isCn" style="margin:30px 0 0 20px;font-size: 14px;color: red;line-height:22px;">
            * 支持图片(jpg/jpeg、png、gif)和视频类型(mp4)。<br/>
            * 在选择框内按住Ctrl键单击鼠标进行多选。<br/>
            * 单个视频大小不超过300M，单张图片大小不超过3M。<br/>
            * 部分mp4视频由于编码问题，浏览器端无法预览，但屏幕上播放正常。<br/>
            <!--            * 横屏播放时：视频/图片宽高比例为 <strong>1.3 : 1</strong>。<br/>-->
            <!--            * 竖屏播放时：视频/图片宽高比例为 <strong>1 : 1.3</strong>，否则可能导致部分内容被裁减。-->
          </div>
          <div v-else style="margin:30px 0 0 20px;font-size: 14px;color: red;line-height:22px;">
            * Supports image (jpg/jpeg, png, gif) and video types (mp4)<br/>
            * Hold down the Ctrl key in the selection box and click the mouse to select multiple<br/>
            * The size of a single video should not exceed 300M, and the size of a single picture should not exceed
            3M.<br/>
            * Some mp4 VIDEOS cannot be PREVIEWED IN the browser due to coding problems, but play normally on the
            screen.<br/></div>
        </el-form>
      </div>
      <div style="width: 400px">
        <el-upload
          :action="uploadUrl"
          :before-upload="beforeUpload"
          :on-error="handlerError"
          :on-success="handleSuccess"
          :data="programData"
          :multiple="true"
          :show-file-list="false"
          accept=".mp4, .png, .jpeg, .jpg, .gif"
          style="display: inline-block;margin-right: 40px;">
          <el-button
            :loading="uploadLoading"
            icon="el-icon-upload2"
            size="mini"
            type="primary">
            {{$l("programCard.upload", "上传")}}
          </el-button>
        </el-upload>
        <el-table :data="programCardList.programList" size="mini" style="width: 100%;margin-top: 10px" border>
          <el-table-column :label="$l('programCard.program','节目')" prop="type" align="center">
            <template slot-scope="scope">
              <img
                v-if="scope.row.attachmentPath.substring(scope.row.attachmentPath.lastIndexOf('.'), scope.row.attachmentPath.length).toLowerCase() === '.jpg' ||
                  scope.row.attachmentPath.substring(scope.row.attachmentPath.lastIndexOf('.'), scope.row.attachmentPath.length).toLowerCase() === '.jpeg' ||
                  scope.row.attachmentPath.substring(scope.row.attachmentPath.lastIndexOf('.'), scope.row.attachmentPath.length).toLowerCase() === '.png' ||
                  scope.row.attachmentPath.substring(scope.row.attachmentPath.lastIndexOf('.'), scope.row.attachmentPath.length).toLowerCase() === '.gif'"
                :src="scope.row.attachmentPath"
                width="200px"/>
              <video
                v-if="scope.row.attachmentPath.substring(scope.row.attachmentPath.lastIndexOf('.'), scope.row.attachmentPath.length).toLowerCase() === '.mp4'"
                controls
                width="200px">
                <source :src="scope.row.attachmentPath" type="video/mp4"/>
                {{$l("programCard.notSupportVideo", "您的浏览器不支持Video标签")}}
              </video>
            </template>
          </el-table-column>
          <el-table-column :label="$t('common.operation')" :width="$l('82','60')" align="center">
            <template slot-scope="scope">
              <el-button
                circle
                icon="el-icon-delete"
                size="mini"
                type="danger"
                @click.native.prevent="handleDelete(scope.$index)"></el-button>
            </template>
          </el-table-column>
          <el-table-column :label="$l('programCard.sorting','排序')" width="80" align="center">
            <template slot-scope="scope">
              <el-button
                size="mini"
                :disabled="scope.$index === 0"
                icon="el-icon-caret-top"
                @click="handleUp(scope.$index)"></el-button>
              <br/>
              <el-button
                size="mini"
                :disabled="scope.$index === programCardList.programList.length - 1"
                icon="el-icon-caret-bottom"
                style="margin-top: 5px"
                @click="handleDown(scope.$index)"></el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <span slot="footer">
      <el-button size="small" @click="dialogVisible = false">{{$l("elevatorNetApply.cancel", "取消")}}</el-button>
      <el-button
        :loading="submitLoading"
        size="small"
        type="primary"
        @click="handleSubmit">{{$l("elevatorNetApply.save", "保存")}}</el-button>
    </span>
  </el-dialog>
</template>

<script>
  const url = "programCard";
  export default {
    data() {
      return {
        uploadLoading: false,
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        uploadUrl: window.config.SERVER_URL + "programCard/upload",
        fileUrls: [],
        programCardList: {
          id: 0,
          cardName: "",
          horizontal: 0,
          notice: "",
          programList: [],
        },
        programData: {
          programCardId: 0,
          isImage: false,
        },
      };
    },
    mounted() {
    },
    methods: {
      open(row) {
        console.log(row);
        this.dialogVisible = true;
        if (row !== 0) {
          this.programCardList.id = row.id;
          this.programData.programCardId = row.id;
        } else {
          this.programData.programCardId = 0;
        }
        if (this.programCardList.id > 0) {
          this.getData();
        }
      },
      getData() {
        this.$http.get("programCard/" + this.programCardList.id).then(res => {
          Object.assign(this.programCardList, res.data);
        });
      },
      onDialogClose() {
        this.$refs.form.resetFields();
        this.$copy(this.$data, this.$options.data.call(this), "ruleValidate");
      },
      handleSubmit() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .save(url, this.programCardList)
              .then((res) => {
                console.log("res.data: " + res.data);
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success(this.$t("common.tip.saveSuccess"));
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
      handleDelete(index) {
        this.$confirm(this.$l("programCard.isDelete", "确定删除吗?"), this.$l("common.tips", "提示"), {type: "warning"}).then(() => {
          this.programCardList.programList.splice(index, 1);
          this.$message.success(this.$t("common.tip.deleteSuccess"));
        });
      },
      beforeUpload(file) {
        let fileName = file.name;
        let pos = fileName.lastIndexOf(".");
        let lastName = fileName.substring(pos, fileName.length);
        let size = file.size / 1024 / 1024;
        if (lastName.toLowerCase() === ".png" ||
          lastName.toLowerCase() === ".jpeg" ||
          lastName.toLowerCase() === ".jpg" ||
          lastName.toLowerCase() === ".gif") {
          if (size > 3) {
            this.$message.error(this.$l("programCard.imageFiles","图片文件不能超过 3MB!"));
            return false; // 返回false中止上传
          } else {
            this.programData.isImage = true;
          }
        }
        if (lastName.toLowerCase() === ".mp4") {
          if (size > 300) {
            this.$message.error(this.$l("programCard.videoFiles","视频文件不能超过 300MB!"));
            return false; // 返回false中止上传
          } else {
            this.programData.isImage = false;
          }
        }
        if (lastName.toLowerCase() !== ".png" &&
          lastName.toLowerCase() !== ".jpeg" &&
          lastName.toLowerCase() !== ".jpg" &&
          lastName.toLowerCase() !== ".gif" &&
          lastName.toLowerCase() !== ".mp4"
        ) {
          this.$message.error(this.$l("programCard.fileType","请上传允许的文件类型"));
          return false; // 返回false中止上传
        }
      },
      handleSuccess(res) {
        console.log(res);
        this.programCardList.programList.push({"attachmentPath": res, "duration": 10});
        this.uploadLoading = false;
        this.$message.success(this.$l("programCard.uploadSuccessful","上传成功，点击保存后生效"));
      },
      handlerError(err) {
        this.$message.error(err.message);
        this.uploadLoading = false;
      },
      handleDown(index) {
        let temp = this.programCardList.programList[index];
        this.programCardList.programList.splice(index, 1);
        this.programCardList.programList.splice(index + 1, 0, temp);
      },
      handleUp(index) {
        let temp = this.programCardList.programList[index];
        this.programCardList.programList.splice(index, 1);
        this.programCardList.programList.splice(index - 1, 0, temp);
      },
    },
  };
</script>

<style lang="scss" scoped></style>
